import { IDictionary } from "@/shared/models/interface/dictionary-model"

export interface ISearchSettings {
    endpoint: string,
    index: string,
    order: string,
    showCategories: boolean,
    disableFiltering: boolean,
    labels: IDictionary<string>,
    shouldDelaySearch: boolean
}

export let defaultConfig: ISearchSettings = {
    endpoint: "",
    index: "",
    order: "",
    showCategories: false,
    disableFiltering: false,
    labels: {},
    shouldDelaySearch: false
}
